"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
require("./stylesheets/app.css");
var organization_1 = require("./models/organization");
var changelogs_1 = require("./models/changelogs");
var WidgetCard_1 = require("./containers/WidgetCard");
var WidgetComponent_1 = require("./containers/WidgetComponent");
var ConfigContext_1 = require("./contexts/ConfigContext");
var utils_1 = require("./libs/utils");
var cache_1 = require("./libs/cache");
var routes_1 = require("./config/routes");
var getLocalData = function (url) {
    var localData = cache_1.getLocalHashData(url);
    if (localData)
        return localData;
    return null;
};
var App = function () {
    var config = hooks_1.useContext(ConfigContext_1.default);
    var _a = hooks_1.useState(getLocalData(routes_1.GET_ORGANIZATION)), organization = _a[0], setOrganization = _a[1];
    var _b = hooks_1.useState(true), organizationLoading = _b[0], setOrganizationLoading = _b[1];
    var _c = hooks_1.useState(null), organizationError = _c[0], setOrganizationError = _c[1];
    var _d = hooks_1.useState(getLocalData(routes_1.GET_CHANGELOGS)), changelogsData = _d[0], setChangelogsData = _d[1];
    var _e = hooks_1.useState(false), changelogsLoading = _e[0], setChangelogsLoading = _e[1];
    var _f = hooks_1.useState(null), changelogsError = _f[0], setChangelogsError = _f[1];
    var _g = hooks_1.useState(1), stage = _g[0], setStage = _g[1];
    var _h = hooks_1.useState({}), translations = _h[0], setTranslations = _h[1];
    var mountedRef = hooks_1.useRef(true);
    var fetchOrganization = function () {
        setOrganizationError(null);
        if (!mountedRef.current)
            return null;
        return organization_1.getOrganization(config.token)
            .then(function (data) {
            setTranslations(data.translations);
            setOrganization(data.organization);
            utils_1.updateWidgetBrandColors(data.brandColors);
            cache_1.updateLocalHashData(routes_1.GET_ORGANIZATION, data);
        })
            .then(function () { return fetchChangelogs(); })
            .catch(function (err) { return setOrganizationError(err.message); })
            .finally(function () { return setOrganizationLoading(false); });
    };
    var fetchChangelogs = function () {
        setChangelogsLoading(true);
        setChangelogsError(null);
        if (!mountedRef)
            return;
        return changelogs_1.getChangelogs(config.token)
            .then(function (data) {
            setChangelogsData(data);
            cache_1.updateLocalHashData(routes_1.GET_CHANGELOGS, data);
            window.parent.postMessage(JSON.stringify({
                action: "indicate",
                payload: data.any_new_changelog,
            }), "*");
            var indication = utils_1.checkIfAllChangelogsViewed(data.changelogs.map(function (c) { return c.id; }));
            if (indication)
                window.parent.postMessage(JSON.stringify({ action: "indicate", payload: false }), "*");
        })
            .catch(function (err) { return setChangelogsError(err.message); })
            .finally(function () { return setChangelogsLoading(false); });
    };
    var handleStageChange = function (nextStage) {
        setStage(nextStage);
        if (stage !== 1 && nextStage === 1)
            return fetchChangelogs();
    };
    hooks_1.useEffect(function () {
        fetchOrganization();
        return function () {
            mountedRef.current = false;
        };
    }, []);
    return (preact_1.h(ConfigContext_1.default.Provider, { value: tslib_1.__assign(tslib_1.__assign({}, config), { translations: translations }) },
        preact_1.h(WidgetCard_1.default, { organization: organization, organizationLoading: organizationLoading, organizationError: organizationError, stage: stage, handleStageChange: handleStageChange },
            preact_1.h(WidgetComponent_1.default, { organization: organization, organizationError: organizationError, changelogsData: changelogsData, changelogsLoading: changelogsLoading, changelogsError: changelogsError, config: config, stage: stage, handleStageChange: handleStageChange }))));
};
exports.default = App;
